<div class="create-circuit">
  <div class="header-create">
    <div class="title">
      {{ pageTitle }}
    </div>
    <div class="subtitle">
      Étape 4 / 4
    </div>
  </div>
  <div class="breadcrumb">
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-1" routerLinkActive="active" class="done">
        Information sur le circuit >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-2" routerLinkActive="active" class="done">
        Ajoutez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-3" routerLinkActive="active" class="done">
        Configurez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-4" routerLinkActive="active">
        Validation
      </a>
    </li>
  </div>
  <div class="content">
    <div class="champs">
      <div class="title">
        Il ne vous reste plus qu'à valider les informations sur votre circuit !
      </div>
      <div class="form">
        <div class="input">
          <input
            type="text"
            placeholder="Nom du circuit *"
            [(ngModel)]="title"
            />
        </div>
        <quill-editor
          [(ngModel)]="description"
          [theme]="'bubble'"
          [modules]="{
            toolbar: false
          }"
          [formats]="['bold', 'link']"
          [placeholder]="'Description...'"
        >
        </quill-editor>

        <div class="medias">
          <div class="title">
            Images de la bannière du haut
          </div>
          <div class="subtitle">
            Préférez des images rectangulaires d'une largeur minimal de 1000px
          </div>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)">
          	<ngx-dropzone-label>
          		<div class="label">Glissez ou cliquez pour déposer des images</div>
          	</ngx-dropzone-label>
          	<ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
              <ngx-dropzone-label>
                <span>{{ f.name }}</span>
                <div class="edit" (click)="onCropImg(f);$event.stopPropagation()">
                  <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Two-Tone" transform="translate(-577.000000, -2725.000000)">
                        <g id="Image" transform="translate(100.000000, 2626.000000)">
                          <g id="Two-Tone-/-Image-/-crop" transform="translate(476.000000, 98.000000)">
                            <g>
                              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                              <path d="M5,17 C5,18.1 5.9,19 7,19 L17,19 L17,23 L19,23 L19,19 L23,19 L23,17 L7,17 L7,1 L5,1 L5,5 L1,5 L1,7 L5,7 L5,17 Z M19,15 L19,7 C19,5.9 18.1,5 17,5 L9,5 L9,7 L17,7 L17,15 L19,15 Z" fill="#FFF"></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </ngx-dropzone-label>
          	</ngx-dropzone-image-preview>
          </div>
        </div>
        <div class="infos-complementaires">
          <div class="title">
            Informations complémentaires
          </div>
          <div class="subtitle">
          </div>
          <div class="input">
            <input
              type="text"
              placeholder="Thème"
              [(ngModel)]="theme"
              />
          </div>
          <div class="input">
            <input
              type="text"
              placeholder="Distance du circuit"
              [(ngModel)]="distance"
              />
          </div>
          <div class="input">
            <input
              type="text"
              placeholder="Durée du circuit"
              [(ngModel)]="time"
              />
          </div>
          <div class="input">
            <input
              type="text"
              placeholder="Contenus"
              [(ngModel)]="content"
              />
          </div>
        </div>
        <div class="video">
          <div class="title">
            Vidéo de la bannière
          </div>
          <div class="subtitle">
            Vous pouvez ajouter une vidéo youtube qui se lance au clic sur la bannière. Cette option est totalement facultative.
          </div>
          <input
            type="text"
            placeholder="ID de la vidéo youtube"
            [(ngModel)]="youtube"
            />
        </div>
        <div class="geoloc" *ngIf="currentRoute">
          <div class="button">
            <input 
              type="checkbox" 
              id="blocking" 
              name="block" 
              [(ngModel)]="currentRoute.blocking_geolocation"
            >
            <label for="blocking">Bloquer par géolocalisation</label>
          </div>
          <div class="subtitle">
            Vous pouvez bloquer l'accès à certaines étapes si l'utilisateur n'est pas à moins de 100m.
          </div>
        </div>
        <div class="geoloc-details" *ngIf="currentRoute && currentRoute.blocking_geolocation">
          <div class="text">
            Bloquer de l'étape
          </div>
          <div class="step">
            <input
              type="number"
              maxlength="1"
              min="0"
              [(ngModel)]="currentRoute.start_step_blocking_geolocation"
            />
          </div>
          <div class="text">
            à l'étape
          </div>
          <div class="step">
            <input
              type="number"
              maxlength="1"
              min="0"
              [(ngModel)]="currentRoute.end_step_blocking_geolocation"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="previsualisation">
      <div class="previ">
        PRÉVISUALISATION
      </div>
      <div class="text">
        Prévisualisation en temps reel
      </div>
    </div>
  </div>
  <div class="boutons-change">
    <div class="bouton-prev">
      <a style="cursor:pointer;" routerLink="/create-circuit-3">
        << Revenir
      </a>
    </div>
    <div class="bouton-next">
      <a style="cursor:pointer;" (click)="validateRoute()">
        Publier
        <svg id="Layer_1" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m477.58 11a305.394 305.394 0 0 1 -7.91 69.22l-.34-.08a130.141 130.141 0 0 1 -61.07-60.8l-.15-.31a303.245 303.245 0 0 1 69.47-8.03z" fill="#ed6337"/><path d="m208.03 261.78-25.13-25.13q2.22-8.235 4.91-16.29a304.131 304.131 0 0 1 46.93-88.67h.01a306.813 306.813 0 0 1 173.36-112.66l.15.31a130.141 130.141 0 0 0 61.07 60.8l.34.08a303.176 303.176 0 0 1 -56.36 117.82 305.378 305.378 0 0 1 -56.52 55.69 303.2 303.2 0 0 1 -87.88 46.2q-8.64 2.865-17.52 5.21l-23.08-23.08z" fill="#e5f5fd"/><path d="m430.52 348.45a39.189 39.189 0 0 0 15.41 9.55 39.464 39.464 0 0 0 -24.93 25 39.464 39.464 0 0 0 -24.93-25 39.464 39.464 0 0 0 24.93-25 39.5 39.5 0 0 0 9.52 15.45z" fill="#3090fc"/><path d="m361.52 298.56a35.767 35.767 0 0 1 0 50.59l-58.56 59.42-33.96-34.38a52.907 52.907 0 0 1 -.09-74.26 303.2 303.2 0 0 0 87.88-46.2l.03.04a35.78 35.78 0 0 0 4.7 44.79z" fill="#475673"/><path d="m228.31 282.06-12.77 51.65-60.66-60.67 53.15-11.26z" fill="#ed6337"/><path d="m189.96 127a35.751 35.751 0 0 0 44.78 4.69 304.131 304.131 0 0 0 -46.93 88.67 52.9 52.9 0 0 1 -73.48-.84l-34.39-33.96 59.43-58.56a35.767 35.767 0 0 1 50.59 0z" fill="#475673"/><path d="m183.74 327.11a21.793 21.793 0 0 1 -19.15 21.66l-27.79 3.45 3.44-27.8a21.833 21.833 0 0 1 43.5 2.69z" fill="#fadf4a"/><path d="m58.52 107.45a39.189 39.189 0 0 0 15.41 9.55 39.464 39.464 0 0 0 -24.93 25 39.464 39.464 0 0 0 -24.93-25 39.189 39.189 0 0 0 15.41-9.55 39.5 39.5 0 0 0 9.52-15.45 39.5 39.5 0 0 0 9.52 15.45z" fill="#3090fc"/><circle cx="336.745" cy="151.84" fill="#50a6ea" r="37.867"/><path d="m408.26 19.34-.15-.31a306.813 306.813 0 0 0 -173.36 112.66h-.01a304.131 304.131 0 0 0 -46.93 88.67q-2.685 8.055-4.91 16.29l20 20q2.22-8.235 4.91-16.29a304.131 304.131 0 0 1 46.93-88.67h.01a306.985 306.985 0 0 1 166.55-110.974 130.115 130.115 0 0 1 -13.04-21.376z" fill="#a6b7d0"/><g fill="#284268"><path d="m361.377 257.848a310.625 310.625 0 0 0 122.205-246.848 6 6 0 0 0 -6-6 309.721 309.721 0 0 0 -190.6 65.542 314.15 314.15 0 0 0 -56.1 56.478 29.879 29.879 0 0 1 -36.679-4.266 41.771 41.771 0 0 0 -59.042-.03l-59.429 58.559a6 6 0 0 0 0 8.542l34.384 33.96a59.1 59.1 0 0 0 67.062 11.081c-.02.074-.042.146-.062.219a6 6 0 0 0 1.55 5.807l17.305 17.308-42.338 8.973a6 6 0 0 0 -3 10.112l21.3 21.3a53.242 53.242 0 0 0 -15.5-6.221c-1.738-.393-3.48-.7-5.163-.91a53.414 53.414 0 0 0 -6.349-.425 52.678 52.678 0 0 0 -37.821 15.55 53.923 53.923 0 0 0 -16.112 38.515 6 6 0 0 0 5.848 6l4.525.115a57.377 57.377 0 0 0 -10.251 41.979 5.984 5.984 0 0 0 5.89 4.812h16.392a6 6 0 0 0 0-12h-10.93c-.17-8 1.586-23.158 16.115-35.979a5.991 5.991 0 0 0 -3.817-10.483l-11.36-.286a42.066 42.066 0 0 1 12.157-24.152 40.9 40.9 0 0 1 28.964-12.071h.313c.955.006 1.913.057 2.87.13a27.672 27.672 0 0 0 -13.422 20.526l-3.441 27.8a6 6 0 0 0 5.954 6.737 6.1 6.1 0 0 0 .737-.045l27.8-3.442a27.771 27.771 0 0 0 20.532-13.466c.086 1.081.145 2.171.147 3.269a41.251 41.251 0 0 1 -12.157 29.351 6 6 0 1 0 8.484 8.485 53.447 53.447 0 0 0 15.254-44.474c-.2-1.673-.492-3.374-.866-5.058a53.284 53.284 0 0 0 -6.273-15.739l20.847 20.845a6 6 0 0 0 10.066-2.8l10.222-41.331 15.562 15.563a6.006 6.006 0 0 0 5.778 1.558c.359-.1.714-.2 1.073-.3a59.088 59.088 0 0 0 10.735 67.766l33.957 34.596a6.222 6.222 0 0 0 4.269 2 6.217 6.217 0 0 0 4.27-2l58.53-59.5a41.884 41.884 0 0 0 0-59.126 29.953 29.953 0 0 1 -4.385-36.526zm110.144-240.787a298.168 298.168 0 0 1 -6.094 54.3 124.694 124.694 0 0 1 -48.365-48.161 297.374 297.374 0 0 1 54.459-6.139zm-352.976 198.186-30.058-29.686 55.123-54.321a29.771 29.771 0 0 1 42.1 0 41.911 41.911 0 0 0 33.476 12.006 311.053 311.053 0 0 0 -36.56 73.713 47.03 47.03 0 0 1 -64.081-1.712zm58.6 116.177a15.809 15.809 0 0 1 -13.292 11.4l-20.158 2.5 2.5-20.153a15.951 15.951 0 0 1 11.78-13.4 15.85 15.85 0 0 1 19.175 19.659zm35.123-9.477-45.329-45.328 39.153-8.3 15.584 15.581zm40.909-23.511-63.557-63.557q1.6-5.66 3.433-11.248c.036-.036.073-.068.109-.1l-.057-.057a301.408 301.408 0 0 1 186.058-189.759q12.725-4.463 25.755-7.728a136.694 136.694 0 0 0 57.732 57.506c-25.666 102.418-104.582 185.892-209.473 214.943zm104.071 46.5-54.291 55.094-29.686-30.057a47.024 47.024 0 0 1 -1.032-64.83 308.378 308.378 0 0 0 73.032-35.806 41.922 41.922 0 0 0 12.007 33.469 29.813 29.813 0 0 1 -.03 42.132z"/><path d="m154.21 384.878a41.7 41.7 0 0 1 -9.71 1.122h-9.452a6 6 0 0 0 0 12h9.452a53.678 53.678 0 0 0 12.5-1.452 6 6 0 0 0 -2.795-11.67z"/><path d="m395.659 260.914a5.974 5.974 0 0 0 3.824-1.379c4.276-3.54 8.516-7.248 12.6-11.02a6 6 0 1 0 -8.137-8.819c-3.931 3.627-8.01 7.192-12.121 10.6a6 6 0 0 0 3.83 10.621z"/><path d="m494.754 102.88a6 6 0 0 0 -7.48 4.007 297.025 297.025 0 0 1 -19.462 48.466c-2.876 5.663-5.979 11.313-9.221 16.792-3.985 6.731-8.29 13.392-12.8 19.8a300.531 300.531 0 0 1 -23.286 29.055 6 6 0 0 0 8.881 8.071 312.778 312.778 0 0 0 24.214-30.222c4.69-6.662 9.169-13.59 13.314-20.593 3.373-5.7 6.6-11.577 9.594-17.469a309.129 309.129 0 0 0 20.249-50.428 6 6 0 0 0 -4.003-7.479z"/><path d="m20.991 250.51a5.982 5.982 0 0 0 4.242-1.757l4.595-4.595a6 6 0 0 0 -8.484-8.485l-4.6 4.595a6 6 0 0 0 4.242 10.242z"/><path d="m42.862 231.124 20.531-20.53a6 6 0 1 0 -8.485-8.486l-20.53 20.53a6 6 0 1 0 8.484 8.486z"/><path d="m25.787 271.18a6 6 0 0 0 8.485 0l24.133-24.134a6 6 0 0 0 -8.486-8.485l-24.133 24.133a6 6 0 0 0 .001 8.486z"/><path d="m65.961 237a5.982 5.982 0 0 0 4.242-1.757l8.922-8.921a6 6 0 1 0 -8.484-8.486l-8.922 8.922a6 6 0 0 0 4.242 10.242z"/><path d="m41.4 278.547-26.66 26.658a6 6 0 0 0 8.485 8.485l26.658-26.658a6 6 0 1 0 -8.485-8.485z"/><path d="m94.856 233.573a6 6 0 0 0 -8.484 0l-31.231 31.227a6 6 0 1 0 8.484 8.486l31.231-31.232a6 6 0 0 0 0-8.481z"/><path d="m212.9 427.226-4.6 4.594a6 6 0 0 0 8.486 8.485l4.594-4.6a6 6 0 0 0 -8.486-8.484z"/><path d="m246.461 393.661-20.53 20.53a6 6 0 1 0 8.484 8.485l20.53-20.53a6 6 0 0 0 -8.484-8.485z"/><path d="m217.338 462.732a6 6 0 0 0 8.485 0l24.134-24.132a6 6 0 1 0 -8.484-8.485l-24.134 24.133a6 6 0 0 0 -.001 8.484z"/><path d="m253.271 426.8a6 6 0 0 0 8.486 0l8.921-8.922a6 6 0 0 0 -8.487-8.485l-8.92 8.921a6 6 0 0 0 0 8.486z"/><path d="m232.951 470.1-26.658 26.657a6 6 0 1 0 8.484 8.486l26.659-26.658a6 6 0 1 0 -8.485-8.485z"/><path d="m277.925 425.125-31.232 31.232a6 6 0 1 0 8.485 8.485l31.231-31.231a6 6 0 1 0 -8.484-8.486z"/><path d="m447.828 352.31a33.632 33.632 0 0 1 -21.135-21.2 6 6 0 0 0 -11.386 0 33.632 33.632 0 0 1 -21.135 21.2 6 6 0 0 0 0 11.38 33.632 33.632 0 0 1 21.135 21.2 6 6 0 0 0 11.386 0 33.632 33.632 0 0 1 21.135-21.2 6 6 0 0 0 0-11.38zm-26.828 17.381a45.932 45.932 0 0 0 -11.668-11.691 45.932 45.932 0 0 0 11.668-11.691 45.932 45.932 0 0 0 11.668 11.691 45.932 45.932 0 0 0 -11.668 11.691z"/><path d="m22.172 122.69a33.632 33.632 0 0 1 21.135 21.2 6 6 0 0 0 11.386 0 33.632 33.632 0 0 1 21.135-21.2 6 6 0 0 0 0-11.38 33.632 33.632 0 0 1 -21.135-21.2 6 6 0 0 0 -11.386 0 33.632 33.632 0 0 1 -21.135 21.2 6 6 0 0 0 0 11.38zm26.828-17.381a45.932 45.932 0 0 0 11.668 11.691 45.932 45.932 0 0 0 -11.668 11.691 45.932 45.932 0 0 0 -11.668-11.691 45.932 45.932 0 0 0 11.668-11.691z"/><ellipse cx="127.038" cy="54" rx="10.985" ry="11"/><ellipse cx="402.038" cy="445" rx="10.985" ry="11"/><path d="m336.744 107.968a43.86 43.86 0 1 0 31.021 74.891 43.87 43.87 0 0 0 -31.022-74.891zm22.536 66.406a31.871 31.871 0 1 1 0-45.071 31.906 31.906 0 0 1 0 45.071z"/></g>
        </svg>
      </a>
    </div>
  </div>
  <div class="cropper" *ngIf="cropImg">
    <app-img-cropper (fileCropped)="onCroppedImg($event)" [img]="imgToCrop" [isModal]="true"></app-img-cropper>
  </div>
</div>